import React, { createContext, useState, useEffect, useContext } from 'react';

// Cria o contexto específico para o CalcCafé
const CalcCafeContext = createContext();

// Hook customizado para facilitar o uso do contexto
export const useCalcCafe = () => {
  return useContext(CalcCafeContext);
};

// Provedor de Contexto que vai envolver as telas de cálculo do CalcCafé
export const CalcCafeProvider = ({ children }) => {
  const [dados, setDados] = useState(() => {
    // Tenta carregar os dados salvos do localStorage ao iniciar
    try {
      const savedData = localStorage.getItem('calcCafeData'); // Chave específica
      return savedData ? JSON.parse(savedData) : {};
    } catch (error) {
      console.error("Erro ao carregar dados do CalcCafé do localStorage:", error);
      return {};
    }
  });

  // Salva os dados no localStorage sempre que eles mudam
  useEffect(() => {
    try {
      localStorage.setItem('calcCafeData', JSON.stringify(dados)); // Chave específica
    } catch (error) {
      console.error("Erro ao salvar dados do CalcCafé no localStorage:", error);
    }
  }, [dados]);

  // Os valores que serão compartilhados com os componentes filhos
  const value = {
    dados,
    setDados,
  };

  return (
    <CalcCafeContext.Provider value={value}>
      {children}
    </CalcCafeContext.Provider>
  );
};
